import React, { useState } from 'react';
import { Check, ChevronDown, ChevronUp, Star, ShieldCheck, X, Clock } from 'lucide-react';
const CHECKOUT_URL = 'https://pay.hotmart.com/H104223457N?checkoutMode=10';
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/mrEAD6N9YUn1PV84RABLbx/1_Principal_.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/4erFD1x23WyW3KUJzibmRC/bono_1.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/7JbhrRKTcszhunuULNUupf/Bono_2.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/uoPCACAkD1hW6rVsprEiaM/bono_3.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/vtFcxRpcq1NztSdENErkgf/bono_4.png'
};
const TESTIMONIALS = [{
  name: 'María G.',
  role: 'Docente • Buenos Aires',
  text: 'Con Economía Lista tengo estructura real. Mis alumnos por fin entienden por qué suben los precios.'
}, {
  name: 'Carlos M.',
  role: 'Prof. Ciencias Sociales • México',
  text: 'La simulación de mercado cambió la dinámica de mi clase. Pasaron de estar aburridos a debatir con pasión.'
}, {
  name: 'Patricia M.',
  role: 'Profesora de Economía • Chile',
  text: 'Es un sistema completo. Mis clases tienen estructura clara y los chicos participan muchísimo más.'
}];
const FAQS = [{
  question: '¿Sirve si no soy especialista en economía?',
  answer: 'Sí. El material explica los conceptos de forma clara y estructurada. No necesitás ser economista.'
}, {
  question: '¿Es solo teoría o tiene actividades?',
  answer: 'Es 100% práctico. Casos reales, debates, actividades grupales y evaluaciones listas para usar.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Acceso inmediato tras la compra. Descarga digital directa. Podés usarlo hoy mismo.'
}];
function CheckoutButton({
  children,
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button onClick={() => window.location.href = CHECKOUT_URL} className={`bg-[#c9a227] hover:bg-[#b08d1f] text-white font-bold py-4 px-8 rounded-lg shadow-lg transform transition hover:scale-105 text-lg md:text-xl w-full md:w-auto uppercase tracking-wide ${className}`} {...props} data-id="element-213">
      {children}
    </button>;
}
function ScrollButton({
  children,
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button onClick={() => document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  })} className={`bg-[#c9a227] hover:bg-[#b08d1f] text-white font-bold py-4 px-8 rounded-lg shadow-lg transform transition hover:scale-105 text-lg md:text-xl w-full md:w-auto uppercase tracking-wide ${className}`} {...props} data-id="element-214">
      {children}
    </button>;
}
function ScrollImage({
  src,
  alt,
  className
}: {
  src: string;
  alt: string;
  className?: string;
}) {
  return <img src={src} alt={alt} className={`cursor-pointer hover:opacity-95 transition ${className}`} onClick={() => document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  })} data-id="element-215" />;
}
function SuperPackFan({
  size = 'md'
}: {
  size?: 'sm' | 'md' | 'lg';
}) {
  const heights = {
    sm: 'h-[200px]',
    md: 'h-[280px] md:h-[340px]',
    lg: 'h-[320px] lg:h-[420px]'
  };
  const mainW = {
    sm: 'w-[100px]',
    md: 'w-[150px] md:w-[190px]',
    lg: 'w-[140px] lg:w-[180px]'
  };
  const sideW = {
    sm: 'w-[70px]',
    md: 'w-[110px] md:w-[140px]',
    lg: 'w-[100px] lg:w-[130px]'
  };
  return <div className={`relative flex items-end justify-center ${heights[size]} mx-auto cursor-pointer`} onClick={() => document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  })} data-id="element-216">
      <img src={IMAGES.bono4} alt="Bono 4" className={`absolute ${sideW[size]} rounded-lg shadow-xl border border-white/10`} style={{
      left: '0%',
      bottom: 0,
      transform: 'rotate(-12deg)',
      zIndex: 1
    }} data-id="element-217" />
      <img src={IMAGES.bono3} alt="Bono 3" className={`absolute ${sideW[size]} rounded-lg shadow-xl border border-white/10`} style={{
      left: '13%',
      bottom: 10,
      transform: 'rotate(-6deg)',
      zIndex: 2
    }} data-id="element-218" />
      <img src={IMAGES.main} alt="Economía Lista" className={`absolute ${mainW[size]} rounded-lg shadow-2xl border-2 border-[#c9a227]/40`} style={{
      left: '50%',
      bottom: 0,
      transform: 'translateX(-50%)',
      zIndex: 5
    }} data-id="element-219" />
      <img src={IMAGES.bono2} alt="Bono 2" className={`absolute ${sideW[size]} rounded-lg shadow-xl border border-white/10`} style={{
      right: '13%',
      bottom: 10,
      transform: 'rotate(6deg)',
      zIndex: 2
    }} data-id="element-220" />
      <img src={IMAGES.bono1} alt="Bono 1" className={`absolute ${sideW[size]} rounded-lg shadow-xl border border-white/10`} style={{
      right: '0%',
      bottom: 0,
      transform: 'rotate(12deg)',
      zIndex: 1
    }} data-id="element-221" />
    </div>;
}
export function SalesPageShort() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  return <div className="font-sans text-gray-800 bg-[#f9f7f2]" data-id="element-222">
      {/* ── HERO ── */}
      <section className="bg-[#1a4a4a] text-white pt-20 pb-16 px-4 md:px-8" data-id="element-223">
        <div className="max-w-5xl mx-auto text-center space-y-6" data-id="element-224">
          <p className="text-xs text-gray-300 tracking-widest uppercase" data-id="element-225">
            Acceso inmediato • Descarga digital • Material imprimible y editable
          </p>

          <h1 className="text-4xl md:text-6xl font-serif font-bold leading-tight text-[#c9a227]" data-id="element-226">
            Economía lista
            <br data-id="element-227" />
            para todo el año
          </h1>

          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto" data-id="element-228">
            Clases desarrolladas, casos reales, actividades prácticas y
            evaluaciones aplicables. Para que la economía deje de ser teoría
            abstracta y se convierta en algo que tus alumnos entienden y viven.
          </p>

          {/* Super pack fan */}
          <div className="py-4" data-id="element-229">
            <SuperPackFan size="md" data-id="element-230" />
            <p className="text-[#c9a227] font-semibold mt-4 text-sm" data-id="element-231">
              Ebook principal + 4 bonos incluidos
            </p>
          </div>

          <div className="space-y-3" data-id="element-232">
            <ScrollButton className="w-full md:w-auto text-xl py-5 shadow-xl shadow-black/30" data-id="element-233">
              Sí, quiero Economía Lista ahora
            </ScrollButton>
            <p className="text-xs text-gray-400" data-id="element-234">
              Acceso inmediato – descarga digital al finalizar la compra
            </p>
          </div>
        </div>
      </section>

      {/* ── DOLOR → SOLUCIÓN (combinado) ── */}
      <section className="bg-white py-14 px-4 md:px-8" data-id="element-235">
        <div className="max-w-4xl mx-auto" data-id="element-236">
          {/* Pain */}
          <div className="text-center mb-10" data-id="element-237">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a4a4a] mb-6" data-id="element-238">
              ¿Te suena familiar?
            </h2>
            <div className="grid md:grid-cols-3 gap-4 max-w-3xl mx-auto" data-id="element-239">
              {[{
              icon: '⏳',
              text: 'Preparar una clase interesante te lleva horas'
            }, {
              icon: '📉',
              text: 'Explicás teoría… pero los alumnos no conectan'
            }, {
              icon: '🤷',
              text: 'Terminás improvisando ejemplos sobre la marcha'
            }].map((item, i) => <div key={i} className="bg-red-50 border border-red-100 rounded-xl p-5 text-center" data-id="element-240">
                  <div className="text-3xl mb-2" data-id="element-241">{item.icon}</div>
                  <p className="text-gray-700 font-medium text-sm" data-id="element-242">
                    {item.text}
                  </p>
                </div>)}
            </div>
          </div>

          {/* Bridge */}
          <div className="text-center py-6 border-y border-gray-100 mb-10" data-id="element-243">
            <p className="text-xl font-bold text-[#1a4a4a]" data-id="element-244">
              El problema no es la economía.
              <br data-id="element-245" />
              <span className="text-[#c9a227]" data-id="element-246">
                El problema es no tener un sistema.
              </span>
            </p>
          </div>

          {/* Solution benefits */}
          <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-247">
            {['Planificás más rápido con secuencias listas', 'Conectás teoría con la vida cotidiana', 'Actividades y evaluaciones listas para usar', 'Estructura anual organizada por unidades', 'Generás debate y pensamiento crítico', 'Evaluás con rúbricas claras incluidas'].map((benefit, i) => <div key={i} className="flex items-center gap-3 bg-[#f0fdfa] p-4 rounded-lg border border-[#1a4a4a]/10" data-id="element-248">
                <Check className="text-green-600 w-5 h-5 flex-shrink-0" data-id="element-249" />
                <span className="font-medium text-gray-700 text-sm" data-id="element-250">
                  {benefit}
                </span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-251">
            <ScrollButton data-id="element-252">Quiero Economía lista todo el año</ScrollButton>
          </div>
        </div>
      </section>

      {/* ── QUÉ INCLUYE (compacto) ── */}
      <section className="bg-[#f9f7f2] py-14 px-4 md:px-8" data-id="element-253">
        <div className="max-w-5xl mx-auto" data-id="element-254">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1a4a4a] mb-2" data-id="element-255">
            ¿Qué incluye Economía Lista™?
          </h2>
          <p className="text-center text-gray-500 mb-10 text-sm" data-id="element-256">
            Todo organizado, listo para usar o adaptar
          </p>

          <div className="flex flex-col md:flex-row gap-10 items-center" data-id="element-257">
            <div className="w-full md:w-2/5" data-id="element-258">
              <ScrollImage src={IMAGES.main} alt="Economía Lista" className="w-full rounded-xl shadow-xl" data-id="element-259" />
            </div>
            <div className="w-full md:w-3/5" data-id="element-260">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-261">
                {['Secuencias didácticas por unidad', 'Casos cotidianos explicados paso a paso', 'Actividades individuales y grupales', 'Debates guiados y dinámicas', 'Evaluaciones listas por unidad', 'Rúbricas para análisis y debate', 'Guías de clase paso a paso', 'Plantillas editables e imprimibles', 'Inflación, créditos, economía del hogar', 'Oferta, demanda y decisiones reales'].map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-700 text-sm" data-id="element-262">
                    <Check className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-263" />
                    <span data-id="element-264">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── BONOS (fila compacta) ── */}
      <section className="bg-[#1a4a4a] text-white py-14 px-4 md:px-8" data-id="element-265">
        <div className="max-w-5xl mx-auto" data-id="element-266">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-[#c9a227] mb-1" data-id="element-267">
            + 4 Bonos incluidos
          </h2>
          <p className="text-center text-gray-400 text-sm mb-8 uppercase tracking-widest" data-id="element-268">
            Sin costo adicional
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-269">
            {[{
            img: IMAGES.bono1,
            title: 'Frases Docentes para Recuperar el Control'
          }, {
            img: IMAGES.bono2,
            title: 'Casos Reales Explicados Fácil'
          }, {
            img: IMAGES.bono3,
            title: 'Kit de Participación para Cursos Difíciles'
          }, {
            img: IMAGES.bono4,
            title: 'Plantillas de Trabajo en Grupo'
          }].map((bono, i) => <div key={i} className="relative" data-id="element-270">
                <span className="absolute top-2 right-2 bg-[#c9a227] text-[#1a4a4a] text-xs font-bold px-2 py-0.5 rounded z-10" data-id="element-271">
                  GRATIS
                </span>
                <ScrollImage src={bono.img} alt={bono.title} className="w-full rounded-lg shadow-lg mb-2" data-id="element-272" />
                <p className="text-xs text-gray-300 text-center leading-snug" data-id="element-273">
                  {bono.title}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIOS (3 compactos) ── */}
      <section className="bg-[#f9f7f2] py-14 px-4 md:px-8" data-id="element-274">
        <div className="max-w-5xl mx-auto" data-id="element-275">
          <h2 className="text-2xl font-bold text-center text-[#1a4a4a] mb-8" data-id="element-276">
            Lo que dicen otros docentes
          </h2>
          <div className="grid md:grid-cols-3 gap-5" data-id="element-277">
            {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" data-id="element-278">
                <div className="flex gap-0.5 mb-3" data-id="element-279">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-[#c9a227] text-[#c9a227]" data-id="element-280" />)}
                </div>
                <p className="text-gray-700 italic text-sm mb-4" data-id="element-281">"{t.text}"</p>
                <div className="flex items-center gap-2" data-id="element-282">
                  <div className="w-8 h-8 bg-[#1a4a4a] rounded-full flex items-center justify-center text-[#c9a227] font-bold text-xs flex-shrink-0" data-id="element-283">
                    {t.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div data-id="element-284">
                    <p className="font-bold text-[#1a4a4a] text-xs" data-id="element-285">{t.name}</p>
                    <p className="text-xs text-gray-400" data-id="element-286">{t.role}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* ── COMPRA ── */}
      <section id="comprar" className="bg-[#1a4a4a] text-white py-20 px-4 md:px-8 text-center" data-id="element-287">
        <div className="max-w-2xl mx-auto" data-id="element-288">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#c9a227] mb-8" data-id="element-289">
            Accedé hoy con precio promocional
          </h2>

          {/* Super pack */}
          <SuperPackFan size="md" data-id="element-290" />
          <p className="text-[#c9a227] font-semibold mt-4 mb-8 text-sm" data-id="element-291">
            Ebook principal + 4 bonos incluidos
          </p>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-[#c9a227]/30 shadow-2xl" data-id="element-292">
            {/* Price */}
            <div className="flex flex-col items-center mb-6" data-id="element-293">
              <span className="text-gray-400 line-through text-base" data-id="element-294">
                $47 USD
              </span>
              <div className="flex items-baseline gap-2" data-id="element-295">
                <span className="text-sm text-gray-300" data-id="element-296">Hoy</span>
                <span className="text-6xl font-bold text-white" data-id="element-297">$13,99</span>
              </div>
              <span className="text-[#c9a227] font-semibold text-xs uppercase tracking-widest mt-1" data-id="element-298">
                Pago único • Acceso inmediato
              </span>
            </div>

            {/* Includes */}
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-xs text-gray-300 mb-6" data-id="element-299">
              {['Descarga digital completa', 'Material imprimible', 'Bonos incluidos', 'Acceso de por vida'].map((item, i) => <span key={i} className="flex items-center gap-1" data-id="element-300">
                  <Check className="w-3.5 h-3.5 text-[#c9a227]" data-id="element-301" /> {item}
                </span>)}
            </div>

            <CheckoutButton className="w-full text-xl py-5 animate-pulse" data-id="element-302">
              Acceder ahora a Economía Lista™
            </CheckoutButton>

            <p className="mt-4 flex items-center justify-center gap-1.5 text-xs text-gray-400" data-id="element-303">
              <ShieldCheck className="w-4 h-4" data-id="element-304" /> Pago 100% seguro
            </p>
          </div>

          {/* Guarantee */}
          <div className="mt-6 bg-white/5 rounded-xl border border-white/10 p-5 text-sm text-gray-300" data-id="element-305">
            <p className="font-bold text-white mb-1" data-id="element-306">
              🛡️ Sin riesgo — Garantía 14 días
            </p>
            <p data-id="element-307">
              Si el material no se adapta a tu realidad docente, te devolvemos
              el dinero. Sin preguntas.
            </p>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="bg-white py-14 px-4 md:px-8" data-id="element-308">
        <div className="max-w-2xl mx-auto" data-id="element-309">
          <h2 className="text-2xl font-bold text-center text-[#1a4a4a] mb-8" data-id="element-310">
            Preguntas frecuentes
          </h2>
          <div className="space-y-3" data-id="element-311">
            {FAQS.map((faq, i) => <div key={i} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-312">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100 transition" data-id="element-313">
                  <span className="font-bold text-[#1a4a4a] text-sm" data-id="element-314">
                    {faq.question}
                  </span>
                  {openFaq === i ? <ChevronUp className="text-gray-500 w-4 h-4 flex-shrink-0" data-id="element-315" /> : <ChevronDown className="text-gray-500 w-4 h-4 flex-shrink-0" data-id="element-316" />}
                </button>
                {openFaq === i && <div className="p-4 bg-white text-gray-700 text-sm border-t border-gray-200" data-id="element-317">
                    {faq.answer}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* ── CIERRE FINAL ── */}
      <section className="bg-[#1a4a4a] py-14 px-4 md:px-8 text-center" data-id="element-318">
        <div className="max-w-xl mx-auto space-y-5" data-id="element-319">
          <p className="text-2xl font-bold text-white leading-snug" data-id="element-320">
            La economía puede ser una materia poderosa…
            <br data-id="element-321" />
            <span className="text-[#c9a227]" data-id="element-322">
              si se conecta con la realidad.
            </span>
          </p>
          <ScrollButton className="w-full md:w-auto" data-id="element-323">
            Sí, quiero Economía lista todo el año
          </ScrollButton>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="bg-[#1a4a4a] text-gray-500 py-6 text-center text-xs border-t border-white/10" data-id="element-324">
        <p data-id="element-325">
          © {new Date().getFullYear()} Economía Lista™. Todos los derechos
          reservados.
        </p>
        <p className="mt-1" data-id="element-326">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}